var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _class2, _descriptor3, _descriptor4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class3, _class4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import ApiRequestTraits, { QueryParamTraits } from "./ApiRequestTraits";
import AutoRefreshingTraits from "./AutoRefreshingTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import TableTraits from "./Table/TableTraits";
export let ApiTableRequestTraits = (_dec = primitiveTrait({
  name: "Kind",
  type: "string",
  description: "Determines how table rows are constructed from this API.\n" + '* PER_ROW: Row major, values are specific to a row in the table eg. [{"col1": 12, "col2": 13}] \n' + "* PER_ID: Values are the same for all objects with the same id.\n" + '* COLUMN_MAJOR: API response is in a column major format, eg. [{"row1": 12, "row2": 13}]. The keys in each list item (eg. "row1") will be used as the row id.\n'
}), _dec2 = primitiveArrayTrait({
  name: "Column major column names",
  type: "string",
  description: 'Used when `kind` is "COLUMN_MAJOR". The name of each column in the order they appear in the API response.'
}), _class = class ApiTableRequestTraits extends mixTraits(ApiRequestTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "kind", _descriptor, this);
    _initializerDefineProperty(this, "columnMajorColumnNames", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "kind", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "PER_ROW";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "columnMajorColumnNames", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ["value"];
  }
}), _class);
export let ApiTableColumnTraits = (_dec3 = primitiveTrait({
  name: "Name",
  type: "string",
  description: "Column name. This must match name in `columns`."
}), _dec4 = primitiveTrait({
  name: "Response data path",
  type: "string",
  description: "Path to relevant data in JSON response. eg: `some.user.name`, `some.users[0].name` or `some.users[].name`. For data to be parsed correctly, it must return a primitive value (string, number, boolean)."
}), _class2 = class ApiTableColumnTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "responseDataPath", _descriptor4, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "responseDataPath", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let ApiTableCatalogItemTraits = (_dec5 = traitClass({
  description: "Creates an <b>api-table</b> type dataset in the catalog, typically used for live sensor data.",
  example: {
    type: "api-table",
    name: "City of Melbourne Pedestrian Counter",
    description: "The City of Melbourne Pedestrian Counting System data has been obtained from the City of Melbourne Open data platform: www.data.melbourne.vic.gov.au to demonstrate the directional movement of pedestrians across the city.\n\nThe counters generate a per minute reading on each of the pedestrian traffic sensors which are then displayed as near-live data.\n\nTo find out more about the City of Melbourne's Pedestrian Counting System or to seek access to their data, please click:\n\nhttp://www.pedestrian.melbourne.vic.gov.au/?_ga=2.244642053.1432520662.1632694466-1456630549.1631675392#date=27-09-2021&time=1",
    defaultStyle: {
      time: {
        spreadFinishTime: true,
        timeColumn: "sensing_datetime"
      }
    },
    initialTimeSource: "stop",
    columns: [{
      name: "total_of_directions"
    }, {
      name: "direction_2"
    }, {
      name: "direction_1"
    }, {
      name: "sensing_datetime"
    }, {
      name: "latitude"
    }, {
      name: "longitude"
    }],
    idKey: "location_id",
    refreshInterval: 60,
    removeDuplicateRows: true,
    apis: [{
      url: "https://melbournetestbed.opendatasoft.com/api/explore/v2.1/catalog/datasets/pedestrian-counting-system-past-hour-counts-per-minute/records?select=location_id%2Csensing_datetime%2Cdirection_1%2Cdirection_2%2Ctotal_of_directions&order_by=sensing_datetime%20DESC&limit=100",
      responseDataPath: "results",
      kind: "PER_ROW"
    }, {
      url: "https://melbournetestbed.opendatasoft.com/api/explore/v2.1/catalog/datasets/pedestrian-counting-system-sensor-locations/exports/json?lang=en&timezone=Australia%2FSydney",
      kind: "PER_ID"
    }]
  }
}), _dec6 = objectArrayTrait({
  name: "APIs",
  type: ApiTableRequestTraits,
  description: 'The apis to use to retrieve the data of the table. Note: you **must** define which columns to use from API response in the `columns` `TableColumnTraits` - for example `[{name:"some-key-in-api-response", ...}]`',
  idProperty: "url"
}), _dec7 = objectArrayTrait({
  name: "API Columns",
  type: ApiTableColumnTraits,
  description: 'ApiTableCatalogItem specific column configuration. Note: you **must** define which columns to use from API response in the `columns` `TableColumnTraits` - for example `[{name:"some-key-in-api-response", ...}]`. This object only adds additional properties',
  idProperty: "name"
}), _dec8 = primitiveTrait({
  name: "Id key",
  type: "string",
  description: "The name of the id property shared between all APIs"
}), _dec9 = primitiveTrait({
  name: "Should append new data",
  type: "string",
  description: "When true, new data received through APIs will be appended to existing data. If false, new data will replace existing data."
}), _dec0 = objectArrayTrait({
  name: "Common query parameters",
  type: QueryParamTraits,
  description: "Common query parameters to supply to all APIs. These are merged into the query parameters for each API.",
  idProperty: "name"
}), _dec1 = objectArrayTrait({
  name: "Common query parameters for updates",
  type: QueryParamTraits,
  description: "Common query parameters to supply to all APIs on subsequent calls after the first call. These are merged into the update query parameters for each API.",
  idProperty: "name"
}), _dec5(_class3 = (_class4 = class ApiTableCatalogItemTraits extends mixTraits(TableTraits, CatalogMemberTraits, LegendOwnerTraits, AutoRefreshingTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "apis", _descriptor5, this);
    _initializerDefineProperty(this, "apiColumns", _descriptor6, this);
    _initializerDefineProperty(this, "idKey", _descriptor7, this);
    _initializerDefineProperty(this, "shouldAppendNewData", _descriptor8, this);
    _initializerDefineProperty(this, "queryParameters", _descriptor9, this);
    _initializerDefineProperty(this, "updateQueryParameters", _descriptor0, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class4.prototype, "apis", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class4.prototype, "apiColumns", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class4.prototype, "idKey", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class4.prototype, "shouldAppendNewData", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class4.prototype, "queryParameters", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class4.prototype, "updateQueryParameters", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class4)) || _class3);
export { ApiTableCatalogItemTraits as default };